import React, { useEffect } from "react";
import { ActionStyles, type ActionStyleType } from "./action-button";
import "./panel.css";

export default function Panel(props: {
  header?: React.ReactNode;
  headerStyle?: ActionStyleType;
  label?: string;
  closed?: boolean;
  fixed?: boolean;
  children: React.ReactNode;
  testid?: string;
}): React.ReactNode {
  const fixed = props.fixed ?? false;
  const [opened, setOpened] = React.useState(!props.closed);

  useEffect(() => {
    setOpened(!(props.closed ?? false) || fixed);
  }, [props.closed, props.fixed]);

  // TODO: no display if no children? does not seem to work perfectly...
  //
  // https://react.dev/reference/react/useLayoutEffect
  //
  //   https://react.dev/reference/react/Component#migrating-a-component-with-lifecycle-methods-from-a-class-to-a-function
  //   => idea: useEffect ? https://react.dev/reference/react/useEffect#my-effect-runs-after-every-re-render

  if (React.Children.count(props.children) === 0) {
    // Show nothing if no children...
    return null;
  }

  function onOpenClose() {
    if (!fixed) {
      setOpened(!opened);
    }
  }

  return (
    <div className="panel-backdrop">
      <div
        className="panel"
        data-role="panel"
        data-testid={props.testid}
        data-status={opened ? "opened" : "closed"}
      >
        <div
          data-role="header"
          className={
            "header " +
            (props.headerStyle
              ? ActionStyles[props.headerStyle].css
              : "default")
          }
          onClick={onOpenClose}
        >
          {fixed || (
            <div id="triangle" className={opened ? "opened" : "closed"}>
              &#9205;
            </div>
          )}
          <div id="custom">
            {props.label ? <label>{props.label}</label> : null}
            {props.header}
          </div>
        </div>
        {opened ? (
          <div data-role="body" className="body">
            {props.children}
          </div>
        ) : null}
      </div>
    </div>
  );
}
